// Get the current frame's height and width:
const getInnerHeight = () => window.innerHeight;
const getInnerWidth = () => window.innerWidth;

// Get the number of pixels an element's content is scrolled vertically and horizontally
// To get the scroll information of current window, use getElementVerticalScroll(document.body) || getElementVerticalScroll(document.documentElement), because Safari use document.body, while other browsers use document.documentElement.
const getElementVerticalScroll = ele => ele.scrollTop;
const getElementHorizontalScroll = ele => ele.scrollLeft;

// Get the entire height and width of an element, including padding
const getElementHeight = ele => ele.scrollHeight;
const getElementWidth = ele => ele.scrollWidth;

const getElementClientHeight = ele => ele.clientHeight;

const getScrollY = () =>
  window.scrollY ||
  getElementVerticalScroll(document.body) ||
  getElementVerticalScroll(document.documentElement);

const setScrollY = val => {
  document.body.scrollTop = val;
  document.documentElement.scrollTop = val;
};

const getAvailableHeightForScroll = () => {
  return getElementHeight(document.documentElement) - getInnerHeight();
};

// When a modal is opened, this function can be used to prevent the background page from scrolling.
const addClassModalOpenOnBody = () => {
  const eleBody = document.querySelector('body');
  if (eleBody && eleBody.classList) eleBody.classList.add('modal-open');
};

// When a modal is closed, this function can be used to remove the modal-open class from element of body, which can disable scrolling on the page.
const removeClassModalOpenFromBody = () => {
  const eleBody = document.querySelector('body');
  if (eleBody && eleBody.classList) eleBody.classList.remove('modal-open');
};

const getElementPositionTop = ele =>
  ele.getBoundingClientRect().top + getScrollY();

const getOmnibarHeight = () => {
  const elementOmnibar = document.querySelector('.omnibar');

  return elementOmnibar ? getElementHeight(elementOmnibar) : 0;
};

const getSubheaderHeight = () => {
  const elementSubheader = document.querySelector('.fixed-header');

  return elementSubheader ? getElementHeight(elementSubheader) : 0;
};

const scrollToShowElementBottom = (ele, offset = 16) => {
  const clientRect = ele.getBoundingClientRect();
  const innerHeight = window.innerHeight;

  if (clientRect.bottom > innerHeight - offset) {
    window.scrollBy({
      top: clientRect.bottom - innerHeight + offset,
      left: 0,
      behavior: 'smooth'
    });
  }
};

// Get the height of Subheader

export {
  getScrollY,
  setScrollY,
  getElementHeight,
  getElementWidth,
  getAvailableHeightForScroll,
  getElementClientHeight,
  addClassModalOpenOnBody,
  removeClassModalOpenFromBody,
  getElementPositionTop,
  getOmnibarHeight,
  getSubheaderHeight,
  scrollToShowElementBottom
};
